import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/pages/products/services/troub.jpg")